package com.appsyde.shared.presentation.screen.component.message

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.appsyde.shared.presentation.screen.component.SpacerXSmall
import com.appsyde.shared.presentation.style.style.AppStylesMessages
import com.appsyde.shared.presentation.style.style.InsightStyles
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun AiToolbarBellowBubble(
    text: String,
    isFirstLoadLoading: Boolean,
    isRegenerating: Boolean,
    onFix: (String) -> Unit,
    onPro: (String) -> Unit,
    onShorter: (String) -> Unit,
    toneLabel: String
) {
    var activeAction by remember { mutableStateOf<String?>(null) }

    val busy = isRegenerating || isFirstLoadLoading
    val hasText = text.isNotBlank()

    LaunchedEffect(isRegenerating) {
        if (!isRegenerating) activeAction = null
    }

    fun trigger(id: String, fire: () -> Unit) {
        if (busy) return
        if (!hasText) return
        if (activeAction != null) return
        activeAction = id
        fire()
    }

    @Composable
    fun ToolbarChip(label: String, id: String, icon: String, onClick: () -> Unit) {
        val isLoading = activeAction == id
        Button(attrs = {
            attr("type", "button")
            classes(
                listOfNotNull(
                    AppStylesMessages.toolbarChip,
                    if (isLoading) AppStylesMessages.toolbarChipLoading else null
                )
            )
            if (busy || isLoading || !hasText) attr("disabled", "true")
            onClick { e ->
                e.preventDefault()
                e.stopPropagation()
                onClick()
            }
        }) {
            Span(attrs = { classes(AppStylesMessages.toolbarChipIcon) }) { Text(icon) }
            Span(attrs = { classes(AppStylesMessages.toolbarChipLabel) }) { Text(label) }
        }
    }


    SpacerXSmall()
    SpacerXSmall()
}
